module.exports = __webpack_public_path__ + "NoiseAware_AppleAppStore210b51082d0b997a99afe2fb2f87e262.png";